import Icon from '../../../components/envago/Icon/Icon';
import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Disclosure } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { getMenuClasses } from '../../MainScreen/NavigationBar/NavigationBar';

interface HighContrastButtonProps {
    smallButton?: boolean;
    forceContrast?: boolean;
    menuButton?: boolean;
    onClick?: () => void;
}

const HighContrastButton = ({ smallButton = true, forceContrast = false, menuButton = false, onClick }: HighContrastButtonProps) => {
    const { t } = useTranslation();
    const [highContrast, setHighContrast] = useState(false);

    useEffect(() => {
        // Observer konfigurieren
        const observer = new MutationObserver(() => {
            setHighContrast(document.body.classList.contains('high-contrast'));
        });

        // Beobachte Änderungen am Attribut "class" des <body>
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        // Aufräumen: Observer beim Unmount beenden
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        console.log('high-contrast: ', highContrast);

        if (highContrast) {
            document.body.classList.add('high-contrast');
        } else {
            document.body.classList.remove('high-contrast');
        }
    }, [highContrast]);

    // Funktion zum Umschalten des Modus
    const toggleHighContrast = () => {
        setHighContrast((prev) => !prev);
    };

    if (menuButton) {
        return (
            <Disclosure.Button as={Fragment}>
                <a
                    key={'high-contrast-button'}
                    href={'high-contrast-button'}
                    role={'menuitem'}
                    aria-label={`Hohen Kontrast ${highContrast ? 'ausschalten' : 'einschalten'}`}
                    onClick={(e) => {
                        e.preventDefault();

                        toggleHighContrast();

                        if (onClick) {
                            onClick();
                        }
                    }}
                    className={getMenuClasses(false, true)}
                >
                    <div className={'flex gap-2 justify-center'}>
                        <Icon
                            path={Icon.Path.mdiContrastCircle}
                            size={'1.5em'}
                            aria={{
                                'aria-hidden': true,
                            }}
                        />
                        {highContrast ? <span>{t('common.highContrastOff')}</span> : <span>{t('common.highContrastOn')}</span>}
                    </div>
                </a>
            </Disclosure.Button>
        );
    }

    return (
        <button
            role={'menuitem'}
            aria-label={`Hohen Kontrast ${highContrast ? 'ausschalten' : 'einschalten'}`}
            onClick={toggleHighContrast}
            className={classNames(
                {
                    'w-8 h-8 cursor-pointer text-center text-menu-item-text bg-menu-item-bg hover:bg-menu-item-bg-hover hover:text-menu-item-text-hover align-middle justify-center items-center flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white':
                        smallButton,
                    'text-gray-900': forceContrast,
                },
                {
                    'p-2 rounded-md cursor-pointer text-center bg-accent text-gray-100 align-middle justify-center items-center flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white':
                        !smallButton,
                },
            )}
        >
            <Icon
                path={Icon.Path.mdiContrastCircle}
                size={'1.5em'}
                aria={{
                    'aria-hidden': true,
                }}
            />
            {!smallButton &&
                (highContrast ? (
                    <span className={'ml-4 text-md'}>{t('common.highContrastOff')}</span>
                ) : (
                    <span className={'ml-4 text-md'}>{t('common.highContrastOn')}</span>
                ))}
        </button>
    );
};

export default HighContrastButton;
